<template>
  <div v-if="loading || (blogs != null && blogs.length > 0)">
    <!-- Skeleton loader -->
    <section v-if="loading">
      <v-skeleton-loader type="heading" class="px-3 mb-8" />

      <v-row class="blogs ma-0 px-3">
        <v-col
          v-for="item in [1, 2, 3]"
          :key="item"
          cols="10"
          sm="7"
          md="4"
          lg="3"
          class="pl-0 pr-6"
        >
          <v-skeleton-loader type="image, article" />
        </v-col>
      </v-row>
    </section>

    <section v-else>
      <h2 class="black--text homepageTitle">
        {{ recentArticlesTitle }}
      </h2>

      <ItemGroup :items="blogs">
        <template v-slot:item="{ item }">
          <v-hover v-slot="{ hover }">
            <v-card
            style="border-radius: 20px;"
              height="100%"
              width="100%"
              class="item-card"
              :elevation="hover ? 5 : 1"
              @click="blogEventSelected(item)"
            >
              <!-- Image -->
              <v-img :aspect-ratio="1.618 / 1" :src="item.PictureUrl">
                <v-card
                  class="pa-3 white--text overlay-card"
                  tile
                  flat
                  color="rgba(180, 180, 180, 0.5)"
                  width="100%"
                >
                  <v-row no-gutters>
                    <v-col>
                      <!-- Release date -->
                      <div class="text-body-2 mb-1">
                        {{ getReleaseDate(item) }}
                      </div>

                      <!-- Title -->
                      <div
                        class="itemTitleFontSize font-weight-bold text-truncate mb-2"
                      >
                        {{ item.Name }}
                      </div>

                      <!-- Subtitle -->
                      <div
                        class="item-description word-break-normal itemDescription-md"
                        v-html="getBlogEventDescription(item)"
                      />
                    </v-col>
                  </v-row>
                </v-card>
              </v-img>
            </v-card>
          </v-hover>
        </template>
      </ItemGroup>
    </section>
  </div>
</template>

<script>
import { addLog } from '@/api/dssRequest';
import uiHelpers from '@/shared/ui_helpers';
import ItemGroup from '@/components/generalComponents/uiComponents/ItemGroup';

export default {
  name: 'BlogEvents',
  mixins: [uiHelpers],
  components: {
    ItemGroup,
  },
  computed: {
    loading() {
      return this.$store.getters['user/loadingPromotions'];
    },
    blogs() {
      return this.$store.getters['user/blogs'];
    },
    userObject() {
      return this.$store.getters['auth/userObjectId'];
    },
    recentArticlesTitle() {
      const pgDetails = this.$store.getters['Account/partnerGroupDetails'];
      if (pgDetails == null || !pgDetails.RecentArticlesTitle) {
        return this.$translate('BLOGS_TITLE');
      }

      return pgDetails.RecentArticlesTitle;
    },
  },
  methods: {
    // return the description if the subTitle is empty
    // (because on phone you can't fill the subtitle in, so in many
    // cases the subtitle should be empty)
    getBlogEventDescription(blogEvent) {
      return blogEvent.Subtitle !== ''
        ? blogEvent.Subtitle
        : blogEvent.Description;
    },
    blogEventSelected(blog) {
      // Add user interaction to log
      addLog(this.userObject, blog.EventId, 'Event', 'Home', -1);
      // Go to event details screen
      this.goToPage('EventDetails', { event_id: blog.EventId });
    },
    getReleaseDate(blog) {
      const date = new Date(blog.ReleaseDateTime * 1000);
      const dateOptions = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      };
      return date.toLocaleDateString('nl', dateOptions);
    },
  },
};
</script>

<style scoped lang="scss">
.blogs {
  overflow-x: auto;
  overflow-y: hidden;
  flex-wrap: nowrap;
}
.item-card:hover {
  & .overlay-card {
    height: 100%;
  }
  & .item-description {
    height: 4.2rem;
  }
}
.overlay-card {
  position: absolute;
  bottom: 0px;
  left: 0px;
  height: 40%;
  min-height: 70px;
  transition: height 0.5s;
}
.item-description {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 4px;
  height: 0rem;
  transition: height 0.5s;
}
</style>
